document.querySelectorAll('header-menu').forEach((menu) => {
  const details = menu.querySelector('details');
  let timeout;

  menu.addEventListener('mouseenter', () => {
    clearTimeout(timeout);
    details.setAttribute('open', '');
  });

  menu.addEventListener('mouseleave', () => {
    timeout = setTimeout(() => {
      details.removeAttribute('open');
    }, 200); // 200ms grace period
  });
  
  // Ensure clicking inside doesn't accidentally close it if the mouse moves slightly
  details.querySelector('.mega-menu__content')?.addEventListener('mouseenter', () => {
    clearTimeout(timeout);
    details.setAttribute('open', '');
  });
});
